import { useEffect, useState } from 'react';

const AdminTourComponent = () => {
  const [Component, setComponent] = useState<React.ComponentType | null>(null);

  useEffect(() => {
    const loadModule = async () => {
      try {
        const path = './AdminTour';
        const module = await import(path);
        setComponent(() => module.default);
      } catch {
        // console.warn('AdminTour non disponible');
      }
    };

    loadModule();
  }, []);

  // console.log('[AdminTourLoader] Rendu, Component =', Component);
  return Component ? <Component /> : null;
};

export default AdminTourComponent;